import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterSessionsReport from 'views/customers/reports/sessionsReport/filterSessionsReport'; // Importing filter for sessions report
import TableSessionsReport from 'views/customers/reports/sessionsReport/tableSessionsReport'; // Importing table for sessions report
import DetailsSessionsReport from 'views/customers/reports/sessionsReport/detailsSessionsReport'; // Importing details view for sessions report
import RecordSessionsReport from 'views/customers/reports/sessionsReport/recordSessionsReport'; // Importing record view for sessions report
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the sessions report view.
 * @extends JetView
 */
export default class sessionsReportView extends JetView {
    /**
     * Configures the layout of the sessions report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [
                DetailsSessionsReport, // Details section of the report
            ],
        };
        const toolbar = {
            view: 'toolbar', // Toolbar for pagination and export options
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing page size
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            var size = $$('datatable').getPager().config.size; // Get current page size
                            var page = $$('datatable').getPage(); // Get current page number
                            var first = size * page; // Calculate first item index
                            var last = first + size - 1; // Calculate last item index
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter for export
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter for export
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            height: screen.width < 500 ? 0 : 600, // Adjust height based on screen width
            rows: [
                FilterSessionsReport, // Filter section for sessions report
                TableSessionsReport, // Table section for sessions report
                toolbar, // Toolbar for pagination and export
            ],
        };
        const avanc = {
            view: 'accordion', // Accordion for advanced details
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }],
        };
        const avancResp = {
            view: 'accordion', // Responsive accordion for advanced details
            multi: true,
            collapsed: true,
            id: 'carousel1',
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'), // Header for advanced details
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Main form view
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section containing filters and table
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the sessions report view.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            $.fn.scrollBottom = function () {
                // jQuery function to get scroll bottom position
                return $(document).height() - this.scrollTop() - this.height();
            };
            if (screen.width < 500) {
                // Conditional for small screens
            }
        });
    }
}

// FILE DOCUMENTED
